/***
 * @file: åºç¡è¡¨æ ¼
 * @author: linkun.he
 * @Date: 2019-06-04 15:49:01
 */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { isEqual } from 'lodash';

@Component({
  selector: 'dt-base-table',
  templateUrl: './base-table.component.html',
  styleUrls: ['./base-table.component.scss'],
})
export class BaseTableComponent implements OnInit, OnChanges {
  currentDataOrder = { pre: null, next: null };
  isEqual = isEqual;
  @Input() showCheckbox = true; // checkboxæ¯å¦æ¾ç¤º
  @Input() showRadio = false; // radioæ¯å¦æ¾ç¤º
  @Input() showOpr = true; // æä½æ¯å¦æ¾ç¤º
  @Input() widthConfig: string[]; // è¡¨æ ¼åå®½è®¾ç½® https://ng.ant.design/components/table/zh#components-table-demo-grouping-columns
  @Input() userDefine: TemplateRef<any>; // ç¨æ·èªå®ä¹çåæ¾ç¤ºæ¹å¼

  // radio
  @Input() radioChooseData: any; // æä½æ¯å¦æ¾ç¤º
  @Input() radioChooseByKey: string; // æä½æ¯å¦æ¾ç¤º

  @Input() showPagination = true; // åé¡µæ¯å¦æ¾ç¤º
  @Input() pageSizeOptions = [10, 20, 30, 40, 50]; // ä¸é¡µæ¾ç¤ºæ°éè®¾ç½®
  @Input() tableInnerBtn: TemplateRef<any>; // è¡¨æ ¼åçæä½æé®
  @Input() tableOuterBtn: TemplateRef<any>; // è¡¨æ ¼å¤çæä½æé®
  @Input() tableData: object[]; // è¡¨æ ¼æ°æ®
  @Input() isLoading: boolean; // æ¯å¦å è½½ä¸­
  @Input() allChecked: boolean; // æ¯å¦å¨é¨éä¸­
  @Input() indeterminate: boolean; // æ¯å¦ä¸ºæ··åç¶æ
  @Input() colData: any; // è¡¨å¤´æ°æ®
  @Input() tableDataTotal: any; // æ°éæ»æ°
  @Input() paginationParam: any; // åé¡µçåæ°
  @Input() dtScroll: object; // åé¡µçåæ°
  @Input() sortByBack = true; // æ¯å¦éè¿åç«¯æåº
  @Input() dtSize = 'default'; // è¡¨æ ¼å¤§å°ï¼'middle' | 'small' | 'default'

  @Output() radioChooseChange = new EventEmitter(); // radioéæ©åå
  @Output() sort = new EventEmitter(); //
  @Output() checkAll = new EventEmitter(); //
  @Output() refreshStatus = new EventEmitter(); //
  @Output() pageSizeChange = new EventEmitter(); //
  @Output() pageIndexChange = new EventEmitter(); //
  @Output() trClick = new EventEmitter(); //
  @Output() link = new EventEmitter(); //
  constructor() {}

  ngOnInit() {}

  ngOnChanges(sc: SimpleChanges): void {
    if ('tableData' in sc && sc.tableData.currentValue) {
      this.currentDataOrder.pre = (this.paginationParam.pageNumber - 1) * this.paginationParam.pageSize + 1;
      this.currentDataOrder.next =
        (this.paginationParam.pageNumber - 1) * this.paginationParam.pageSize + sc.tableData.currentValue.length;
    }
  }
  rowLink(data) {
    console.log('lnk');
    this.link.emit(data);
  }

  rowClick(data) {
    console.log(data, 'line');
    this.trClick.emit(data);
  }
  onRadioChooseChange(radioChooseData) {
    this.radioChooseChange.emit(radioChooseData);
  }

  doSort(evt) {
    this.sortByBack ? this.sort.emit(evt) : this.sortByWeb(evt);
  }

  getValue(data, e) {
    return data[e.key] || '';
  }

  // åç«¯æåº
  sortByWeb(e) {
    if (e.key && e.value) {
      this.tableData = this.tableData.sort((a, b) => {
        const _a = this.getValue(a, e);
        const _b = this.getValue(b, e);
        if (typeof _a === 'number' && typeof _b === 'number') {
          // æ°å­æåºç´æ¥æå¤§å°æ
          if (e.value === 'ascend') {
            return _a - _b;
          } else if (e.value === 'descend') {
            return _b - _a;
          }
        } else {
          // å­ç¬¦ä¸²æåºæé¦å­æ¯æ
          if (e.value === 'ascend') {
            return _a.localeCompare(_b, 'zh-Hans-CN');
          } else if (e.value === 'descend') {
            return _b.localeCompare(_a, 'zh-Hans-CN');
          }
        }
      });
    }
  }

  doCheckAll(evt) {
    this.checkAll.emit(evt);
  }

  doRefreshStatus(evt) {
    this.refreshStatus.emit(evt);
  }

  onPageSizeChange(evt) {
    this.pageSizeChange.emit(evt);
  }

  onPageIndexChange(evt) {
    this.pageIndexChange.emit(evt);
  }
}
